<template>
  <div ref="transition" class="transition">
    <!-- Bloques de transición dinámicos -->
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  mounted () {
    this.ensureGridReady().then(() => this.playPageLoadAnimation())
    this.setupRouterListener()
    window.addEventListener('resize', this.ensureGridReady)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.ensureGridReady)
    if (this.unwatch) this.unwatch()
  },

  methods: {
    async ensureGridReady () {
      await this.adjustGrid()
      return new Promise(resolve => setTimeout(resolve, 50))
    },

    async adjustGrid () {
      const transition = this.$refs.transition
      if (!transition) return

      // Definir el número de columnas según el tamaño de la pantalla
      let columns = 8
      if (window.innerWidth <= 767) columns = 6
      if (window.innerWidth <= 479) columns = 4

      transition.style.gridTemplateColumns = `repeat(${columns}, 1fr)`

      // Calcular el tamaño de los bloques (asegurar que sean cuadrados)
      const blockSize = window.innerWidth / columns
      const rowsNeeded = Math.ceil(window.innerHeight / blockSize)

      transition.style.gridTemplateRows = `repeat(${rowsNeeded}, ${blockSize}px)`

      // Limpiar el grid antes de regenerarlo
      transition.innerHTML = ''

      const totalBlocks = columns * rowsNeeded

      for (let i = 0; i < totalBlocks; i++) {
        const block = document.createElement('div')
        block.classList.add('transition-block')

        // Aplicar tamaño cuadrado
        block.style.width = `${blockSize}px`
        block.style.height = `${blockSize}px`

        transition.appendChild(block)
      }
    },

    playPageLoadAnimation () {
      gsap.set(this.$refs.transition, { display: 'grid', background: 'transparent' })
      gsap.set('.transition-block', { autoAlpha: 1, backgroundColor: '#000' })

      gsap.timeline({
        onComplete: () => gsap.set(this.$refs.transition, { display: 'none' }),
        defaults: { ease: 'linear' }
      }).fromTo('.transition-block',
        { autoAlpha: 1 },
        { autoAlpha: 0, duration: 0.6, stagger: { amount: 0.75, from: 'random' } }
      )
    },

    playPageLeaveAnimation (to) {
      gsap.set(this.$refs.transition, { display: 'grid' })

      gsap.timeline({
        onComplete: () => this.$router.push(to)
      }).fromTo('.transition-block',
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 0.2, stagger: { amount: 0.5, from: 'random' } }
      )
    },

    setupRouterListener () {
      this.unwatch = this.$watch('$route', async (to, from) => {
        if (from) {
          await this.ensureGridReady()
          this.playPageLeaveAnimation(to.fullPath)
        } else {
          this.playPageLoadAnimation()
        }
      }, { immediate: true })
    }
  }
}
</script>

<style scoped>
.transition {
  z-index: 10000;
  background-color: transparent;
  display: none;
  grid-template-columns: repeat(8, 1fr);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.transition-block {
  aspect-ratio: 1;
  background-color: #000 !important;
  width: 100%;
  opacity: 1 !important;
}

@media screen and (max-width: 767px) {
  .transition {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media screen and (max-width: 479px) {
  .transition {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
